/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IceNavService } from 'projects/icemedx-lib/src/components/ice-nav/ice-nav.service';
import { Iceutility } from '../../../../../projects/icemedx-lib/src/services/iceutility';
import { LoginService } from '../../../../../projects/icemedx-lib/src/login/login.service';
import {
  IcecontrolSettings
} from '../../../../../projects/icemedx-lib/src/components/models/icesettings';
import { LoginConfig } from '../../../../icemedx-lib/src/login/login.config';

@Component({
  selector: 'message-toolbar',
  templateUrl: './message-toolbar.component.html',
  styleUrls: ['./message-toolbar.component.scss']
})
export class MessageToolbarComponent implements OnInit {
  @Input() SetActive: Function = (event) => {
    let basePath: string = "messages";
    this.router.navigate([this.GetFormattedPath(basePath + "/" + event.value.toLowerCase())]);
  }

  btnSettings: IcecontrolSettings = new IcecontrolSettings(
    "icebutton",
    {
      text: "New Message",
      class: [],
      glyphClass: "fa-envelope-open"
    },
    null,
    null
  )
  buttonGroupSettings = {
    activeButton: "Inbox",
    groupSettings: [
      { text: "Inbox", onclick: this.SetActive },
      { text: "Sent", onclick: this.SetActive },
      { text: "Drafts", onclick: this.SetActive },
      { text: "Invitations", onclick: this.SetActive },
      { text: "Action-Items", onclick: this.SetActive },
      { text: "Deleted", onclick: this.SetActive },
      { text: "Processed", onclick: this.SetActive }
    ]
  };
  showGroup: boolean = false;

  constructor(private activeRoute: ActivatedRoute, private navSvc: IceNavService, private router: Router,
    private loginSvc: LoginService) {
    let userInfo = this.loginSvc.GetSessionUserInfo();
    if (this.loginSvc.IsSignedIn(userInfo)) {
      this.showGroup = true;
      this.buttonGroupSettings.groupSettings.push({ text: "HIE-Trans", onclick: this.SetActive });
    }
  }

  ngOnInit() {
    let activeButton = this.activeRoute.snapshot.url[this.activeRoute.snapshot.url.length - 1].path;
    activeButton = activeButton === "messages" ? "inbox" : activeButton;
    this.buttonGroupSettings.activeButton = activeButton;
  }

  ///////////////////////
  // public functions //
  ///////////////////////

  public onNewMessage() {
    this.router.navigate([this.navSvc.buildRoute("newmessage", false)]);
  }

  ///////////////////////
  // private functions //
  ///////////////////////

  private GetFormattedPath(path: string): string {
    let env = Iceutility.getCurrentEnvironment();
    let app_path = env.app_path;
    return LoginConfig.getFormattedPath(app_path, path);
  }
}
